import { render, staticRenderFns } from "./BaseSearchDropdown.vue?vue&type=template&id=f5944b5a&scoped=true&"
import script from "./BaseSearchDropdown.vue?vue&type=script&lang=js&"
export * from "./BaseSearchDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BaseSearchDropdown.vue?vue&type=style&index=0&id=f5944b5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5944b5a",
  null
  
)

export default component.exports